<template>
  <v-row :class="[!isMobile && 'mx-8 my-12']" justify="center">
    <v-flex lg6 xs12>
      <v-card :class="[isMobile ? 'pa-0' : 'pa-4']">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              {{ company.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-identifier</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>{{ company.sellerId }}</v-list-item-subtitle>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>{{ company.email }}</v-list-item-subtitle>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>{{
              company.monitoringEnabled ? "mdi-robot" : "mdi-robot-off"
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>{{
            company.monitoringEnabled
              ? "Мониторинг включен"
              : "Мониторинг выключен"
          }}</v-list-item-subtitle>
        </v-list-item>

        <v-list-item class="mt-2">
          <v-list-item-subtitle class="text-left text-h5">
            {{ company.subscription.planName }}
          </v-list-item-subtitle>
        </v-list-item>

        <v-divider></v-divider>

        <v-list class="transparent">
          <v-list-item>
            <v-list-item-title>Месячная оплата</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              {{ toMoneyFormat(company.subscription.monthlyFee) }} ₸
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Лимит по товарам</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              {{ company.productLimit }} шт
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Истекает через</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              {{ company.subscription.daysLeft }} дней
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Подробнее о тарифе</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              <a href="https://marketradar.kz/" target="_blank"
                >marketradar.kz</a
              >
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import FormatMixin from "@/mixins/Format";
import ScreenResolutionMixin from "@/mixins/ScreenResolution";

export default {
  name: "CompanyAbout",
  mixins: [FormatMixin, ScreenResolutionMixin],
  computed: {
    ...mapGetters("profile", {
      company: "company",
    })
  }
};
</script>
